<template>
  <v-container>
    <h1>{{ marketplace.name }}</h1>
    <p>{{ marketplace.description }}</p>

    <v-card v-if="isDemoMode" class="mt-5 mb-5 red lighten-4">
      <v-banner icon="mdi-information-variant" color="indigo lighten-5">
        Her kan du se en liste over tilgjengelige butikker på denne
        markedsplassen. En markedsplass er en samling av butikker som naturlig
        henger sammen. Det kan være butikker i et bysentrum, på et kjøpesenter,
        et marked, Reko-Ring eller lignende.
        <br /><br />
        Her får kunder lett oversikt over hvem de kan bestille varer fra og
        gjennomføre et kjøp.
      </v-banner>
    </v-card>

    <v-card
      v-if="marketplace.vendors.length > 0"
      class="lighten-5 deep-purple mt-5"
      elevation="3"
    >
      <v-card-title class="white--text deep-purple">
        <v-icon color="white" class="pr-2">mdi-store</v-icon>
        Butikker
      </v-card-title>
      <VendorList :vendors="marketplace.vendors" />
    </v-card>
    <v-alert v-else type="error" class="m-5"
      >Denne markedsplassen har ikke satt opp noen butikker enda.</v-alert
    >
  </v-container>
</template>

<script>
import backend from "@/backend";
import VendorList from "@/components/VendorList";

export default {
  name: "MarketplacDetail",

  components: {
    VendorList,
  },

  props: {
    marketplaceId: {
      type: String,
      required: true,
      default: null,
    },
  },

  data() {
    return {
      marketplace: {
        vendors: [],
      },
    };
  },

  computed: {
    isDemoMode: function () {
      return process.env.VUE_APP_DEMO_MODE == 1;
    },
  },

  async created() {
    this.marketplace = await backend.get(`marketplaces/${this.marketplaceId}/`);
  },
};
</script>
